import { numberToPrettyString, plural } from '@cian/utils';
import { BUILDING_CLASS_LABELS, SHOPPING_CENTER_SCALE_LABELS } from 'shared/constants/buildingLabels';
import type { IBuildingCard } from 'shared/types/buildingCard';
import { formatNumber, noBreak } from 'shared/utils/format';

import { getParkingValue } from './getParkingValue';
import { NBSP } from 'shared/constants/text';

export interface IMainProp {
  name: string;
  value: string;
}

/** Основные характеристики как `detail/index.html` монолита: пустые не выводим, кроме парковки */
export function getMainProps(card: IBuildingCard): IMainProp[] {
  const props: IMainProp[] = [];
  const classLabel = card.buildingClassType ? BUILDING_CLASS_LABELS[card.buildingClassType] : undefined;
  const scaleLabel = card.shoppingCenterScaleType
    ? SHOPPING_CENTER_SCALE_LABELS[card.shoppingCenterScaleType]
    : undefined;
  const parking = getParkingValue(card);

  if (classLabel) {
    props.push({ name: 'Класс', value: classLabel });
  }
  if (card.totalArea) {
    props.push({ name: 'Общая площадь', value: `${noBreak(numberToPrettyString(card.totalArea))}${NBSP}м²` });
  }
  if (card.buildYear) {
    props.push({ name: 'Год постройки', value: String(card.buildYear) });
  }
  if (card.floorsTo) {
    props.push({
      name: 'Этажность',
      value: `${noBreak(formatNumber(card.floorsTo))}${NBSP}${plural(card.floorsTo, ['этаж', 'этажа', 'этажей'])}`,
    });
  }
  if (scaleLabel) {
    props.push({ name: 'Масштаб', value: scaleLabel });
  }
  if (parking !== null) {
    props.push({ name: 'Парковка', value: parking });
  }

  return props;
}
